import { ControlPanel } from './control-panel'
import { API_ORIGIN, API_PATH } from './config'

console.log("CP starting");

const instance = new ControlPanel(`${API_ORIGIN}/${API_PATH}`)
window.ControlPanel = instance

async function onMessage(event: MessageEvent) {
    console.debug("CP message received type:"+event.data.type);
    console.debug(event)

    //TODO
    //if (event.origin !== API_ORIGIN) {
    //  return
    //}

    if (event.data.type !== 'cp:init') {
        return
    }

    instance.init({ 
        url: event.data.url,
        decision: event.data.decision,
        bubble: event.data.bubble,
        meetWaulter: event.data.meetWaulter,
        alert: event.data.alert,
        cb: event.data.cb,
        userInitials: event.data.userInitials,
        iconStyle: event.data.iconStyle,
        webDetail: event.data.webDetail
                 });
}

window.addEventListener('message', onMessage);

console.log("CP loaded, origin:"+window.origin);

window.postMessage({type:'cp:loaded'},window.origin);
